export const sortFields = (a, b) => {
  if (typeof a.row !== 'number' || typeof b.row !== 'number' || typeof a.column !== 'number' || typeof b.column !== 'number') {
    return 0;
  }
  if (a.row > b.row) {
    return 1;
  }
  if (a.row < b.row) {
    return -1;
  }
  if (a.column > b.column) {
    return 1;
  }
  if (a.column < b.column) {
    return -1;
  }
  return 0;
};
export const getSortedFields = function (form, opts) {
  if (opts === void 0) {
    opts = {};
  }
  if (!form) {
    return [];
  }
  const {
    filter = () => true,
    stepId
  } = opts;
  const allSteps = form.steps || [];
  const steps = stepId ? allSteps.filter(step => step.id === stepId) : allSteps;
  return steps.map(step => {
    var _step$layout;
    return [...(((_step$layout = step.layout) == null || (_step$layout = _step$layout.large) == null ? void 0 : _step$layout.items) || [])].sort(sortFields);
  }).flat().reduce((result, item) => {
    var _form$fields;
    const field = (_form$fields = form.fields) == null ? void 0 : _form$fields.find(_ref => {
      let {
        id
      } = _ref;
      return id === item.fieldId;
    });
    if (!field || !filter(field)) {
      return result;
    }
    result.push(field);
    return result;
  }, []);
};
//# sourceMappingURL=sort-fields.js.map